/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 0 = NOTICE 1 = WARNING 2 = CRITICAL
 */
export type WafRuleSeverityType = 0 | 1 | 2;

export const WafRuleSeverityType = {
  NOTICE: 0 as WafRuleSeverityType,
  WARNING: 1 as WafRuleSeverityType,
  CRITICAL: 2 as WafRuleSeverityType,
};
